import { render, staticRenderFns } from "./PatientEditors.vue?vue&type=template&id=568417ad&scoped=true&"
import script from "./PatientEditors.vue?vue&type=script&lang=js&"
export * from "./PatientEditors.vue?vue&type=script&lang=js&"
import style0 from "./PatientEditors.vue?vue&type=style&index=0&id=568417ad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568417ad",
  null
  
)

export default component.exports